import { useQueryClient } from "@tanstack/react-query";
import { useContext, useState } from "react";
import useLocales from "src/hooks/useLocales";
import { useLoginDemoRequest } from "src/services/demo/commands/login";
import { LoginDemoResponse } from "src/services/demo/commands/NetTypes";
import SnackbarUtils from "src/utils/SnackbarUtils";

import Context from "../../../context";
import CodeContext from "../context";

export type VerifyForm = {
	email: string;
};

export default function useConfirmCode() {
	const [loading, setLoading] = useState(false);

	const { actions, state } = useContext(Context);
	const codeContext = useContext(CodeContext);

	const { translate } = useLocales();
	const { mutate } = useLoginDemoRequest();
	const queryClient = useQueryClient();

	const onSuccess = ({ token }: LoginDemoResponse) => {
		actions.onSetSessionToken(token);
		queryClient.setQueryData(["demo", "sesion"], token);
		setLoading(false);
	};

	const onError = () => {
		setLoading(false);
		let message = "demo.email_confirmation_error_3";
		SnackbarUtils.error(translate(message));
	};

	const onSubmit = () => {
		setLoading(true);
		const code = codeContext.state.code.join("");
		mutate(
			{ code, email: state.email },
			{
				onSuccess,
				onError
			}
		);
	};

	return {
		onSubmit,
		loading
	};
}
